import React, {createElement, useState, useEffect} from 'react'
import { Helmet } from 'react-helmet'
import { graphql, Link } from 'gatsby'
import marksy from 'marksy/jsx'


import PageContainer from '../components/page-container'
import Section from '../components/section'
import Header from '../components/header'
import Footer from '../components/footer'
import DownloadButtons from '../components/download-icons'
import DownloadBanner from '../components/download-banner'
import Metadata from '../components/metadata'
import Spacer from "../components/spacer";
import { HeroPrimary, CopyPrimary, CopyPrimaryDiv, HeroTertiary, CopySecondary} from "../components/typography";
import '../components/styles/buttons.css'
import './style.css'

const compile = marksy({createElement})

function Muted(props) {
  return (
    <svg width={80} height={70} {...props}>
      <defs>
        <filter
          x="-67.5%"
          y="-90%"
          width="235%"
          height="280%"
          filterUnits="objectBoundingBox"
          id="prefix__a"
        >
          <feOffset dy={5} in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur
            stdDeviation={4.5}
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          />
          <feColorMatrix
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
            in="shadowBlurOuter1"
            result="shadowMatrixOuter1"
          />
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      <g
        filter="url(#prefix__a)"
        transform="translate(20 20)"
        fill="#F6F6F6"
        fillRule="evenodd"
      >
        <path d="M34.067 14.084l4.647-4.646c.404-.404.472-1.01.161-1.398a15.375 15.375 0 00-2.394-2.393c-.385-.312-.991-.243-1.396.162l-4.646 4.45-4.649-4.452c-.402-.403-1.01-.472-1.396-.16a15.556 15.556 0 00-2.391 2.391c-.315.388-.245.995.16 1.398l4.648 4.648-4.649 4.647c-.403.403-.472 1.01-.16 1.397a15.54 15.54 0 002.392 2.391c.387.314.994.244 1.397-.16l4.647-4.648 4.646 4.647c.404.405 1.01.473 1.398.161a15.375 15.375 0 002.393-2.393c.311-.385.242-.992-.161-1.396l-4.647-4.646zM15.443.089a2.485 2.485 0 00-2.772 1.088L9.53 6.32c-1.851.382-4.062.788-6.768 1.24A2.416 2.416 0 00.864 9.193a16.95 16.95 0 000 10.689 2.416 2.416 0 001.9 1.634c2.705.452 4.916.858 6.766 1.24l3.14 5.142a2.485 2.485 0 002.773 1.089 2.43 2.43 0 001.809-2.335V2.423A2.43 2.43 0 0015.443.09" />
      </g>
    </svg>
  )
}

function Unmuted(props) {
  return (
    <svg width={78} height={72} {...props}>
      <defs>
        <filter
          x="-71.1%"
          y="-84.4%"
          width="242.1%"
          height="268.8%"
          filterUnits="objectBoundingBox"
          id="prefix__a"
        >
          <feOffset dy={5} in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur
            stdDeviation={4.5}
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          />
          <feColorMatrix
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
            in="shadowBlurOuter1"
            result="shadowMatrixOuter1"
          />
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      <g
        filter="url(#prefix__a)"
        transform="translate(20 20)"
        fill="#FFF"
        fillRule="evenodd"
      >
        <path d="M22.364 5.518l-3.43 3.125c2.039 1.99 3.671 4.603 3.671 7.358 0 2.754-1.632 5.367-3.672 7.357l3.431 3.125c2.903-2.833 4.489-6.556 4.489-10.482 0-3.927-1.586-7.65-4.489-10.483m-7.37-3.23a2.292 2.292 0 00-2.549.99L9.56 7.965c-1.7.347-3.732.717-6.22 1.128a2.213 2.213 0 00-1.744 1.489 15.305 15.305 0 000 9.736c.26.78.924 1.353 1.745 1.488 2.487.412 4.518.781 6.219 1.13l2.886 4.684c.552.895 1.651 1.235 2.549.99.982-.264 1.662-1.134 1.662-2.126V4.414c0-.992-.68-1.862-1.662-2.126M27.939 0L24.6 3.114c3.565 3.47 5.88 8.046 5.88 12.886s-2.315 9.417-5.879 12.886L27.94 32c4.424-4.306 6.86-9.988 6.86-16 0-6.012-2.436-11.694-6.86-16" />
      </g>
    </svg>
  )
}

function PlayButton(props) {
  return (
    <svg width={64} height={64} {...props}>
      <g fill="none" fillRule="evenodd">
        <circle fill="#FFF" opacity={0.851} cx={32} cy={32} r={32} />
        <path
          d="M26.813 15.282c-1.467-.791-3.286.172-3.39 1.791-.581 9.043-.546 20.538 0 28.855.107 1.616 1.919 2.581 3.39 1.791 10.326-5.566 19.243-14.358 19.593-14.73a2.158 2.158 0 000-2.975c-.35-.373-9.267-9.165-19.593-14.732z"
          fill="#FF7D53"
        />
      </g>
    </svg>
  )
}


const styles = {
  '--logo-color': 'var(--white)',
  '--color': 'var(--white)',
  '--active-color': 'var(--coral)',
  '--background-color': 'var(--light-purple)',
}

function Hero ({hed, dek}) {
  const styles = {
    '--logo-color': 'var(--white)',
    '--color': 'var(--white)',
    '--active-color': 'var(--coral)',
    '--background-color': 'var(--light-purple)',
  }

  const checkIsMobile = () => {
    if (typeof window === 'undefined') return true;
    return window.innerWidth < 1080;
  }

  const [isMobile, setIsMobile] = useState(false);
  const [muted, setMuted] = useState(true)
  const [playing, setPlaying] = useState(false)
  const [isFirstPause, setIsFirstPause] = useState(true)

  useEffect(() => {
    setIsMobile(checkIsMobile())
  }, [])

  useEffect(() => {
    if (typeof window === 'undefined') {
      return false;
    }

    function handleResize() {
      setIsMobile(checkIsMobile())
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleTogglePlay = (e) => {
    e.preventDefault();
    setIsFirstPause(false);

    if (playing) {
      document.querySelector('video').pause()
      setPlaying(false)
    } else {
      document.querySelector('video').play()
      setPlaying(true)
    }
  }

  const handleMuteToggle = (e) => {
    e.preventDefault();
    setMuted(!muted);
  }

  return (
    <Section className="home-hero" styles={styles} >
      <button className={'reset home-hero__mute-toggle flex flex-center'} onClick={handleMuteToggle}>
        {muted && <Muted />}
        {!muted && <Unmuted />}
      </button>
      <button className={'reset home-hero__play-toggle flex flex-center'} onClick={handleTogglePlay}>
        {!playing && <PlayButton />}
      </button>
      <div className={`home-hero__video-group flex flex-center ${isFirstPause ? 'initial-state' : ''}`}>
        <video width={'982'} height={'1080'} className={'home-hero__video'} poster={'/home/hero-video-poster.jpg'} muted={isMobile ? false : muted} playsInline autoPlay={!isMobile} loop >
          <source src={"/home/home-video-why.mp4"} type={'video/mp4'}  />
        </video>
      </div>
      <div className={'home-hero__content'}>
        <div className={"home-hero__grid grid"}>
          <div className={'home-hero__copy column-start-1 column-end-6 column-start-1--d column-end-12--t column-end-6--d'}>
            <Spacer size={[0, 100]} />
            <HeroPrimary className={'home-hero__hed'}>
              <span dangerouslySetInnerHTML={{ __html: hed }} /></HeroPrimary>
            <Spacer size={[0, 24]} />
            <CopyPrimary className={'home-hero__dek'}><span dangerouslySetInnerHTML={{ __html: dek }} /></CopyPrimary>
            <Spacer size={[20, 64]} />
            <div className={'home-hero__download-group flex flex-center'}>
              <DownloadButtons className={'home-hero__download'} />
            </div>
            <Spacer size={[50, 244]} />
          </div>
        </div>
      </div>
    </Section>
  )
}


function WalkThrough ({hed, dek}) {
  const styles = {
    '--color': 'var(--light-purple)',
    '--background-color': 'var(--white)',
  }

  return (
    <Section className="home-walk-through" styles={styles} >
      <div className={"home-walk-through-grid grid"}>
        <div className={'column-start-1 column-end-6 column-end-5--t flex flex-center'}>
          <div className={'home-walk-through__frame'}>
            <img className={'home-walk-through__video-frame'} src={'/home/phone-frame.png'} />
            <video width={533} height={1152} className={'home-walk-through__video'} poster={'/home/product-demo-poster.jpg'} playsInline muted autoPlay loop >
              <source src={"/home/product-demo.mp4"} type={'video/mp4'}  />
            </video>
          </div>
        </div>
        <div className={'home-walk-through__copy column-start-1 column-end-6 column-start-6--t column-end-12--t column-end-11--d'}>
          <Spacer size={[40, 175]} />
          <HeroTertiary className={'home-walk-through__hed'}><span dangerouslySetInnerHTML={{ __html: hed }} /></HeroTertiary>
          <Spacer size={[20, 24]} />
          <CopyPrimary className={'home-walk-through__dek'}><span dangerouslySetInnerHTML={{ __html: dek }} /></CopyPrimary>
          <Spacer size={[0, 56]} />
          <DownloadButtons className={'home-walk-through__download'} />
        </div>
        <div className={'home-walk-through__kidsafe-group column-start-1 column-end-6 column-end-5--t flex flex-center'}>
          <div>
            <Spacer size={[24, 40]} />
            <a
              className={'home-walk-through__kidsafe-link'}
              href="http://www.kidsafeseal.com/certifiedproducts/kinzoo_app.html"
              rel="noopener"
              target="_blank"
            >
              <img className={'home-walk-through__kidsafe'}
                alt="Kinzoo (mobile app) is certified by the kidSAFE Seal Program."
                src="/kidSAFE-COPPA.png" />
            </a>
          </div>
        </div>
      </div>
    </Section>
  )
}


function SocialProof({quotes}) {
  const styles = {
    '--color': 'var(--light-purple)',
    '--background-color': 'var(--light-purple)',
  }

  const leftColumn = "column-start-1 column-end-6 column-start-1--t column-start-2--d column-end-6--t"
  const rightColumn = "column-start-1 column-end-6 column-start-7--t column-end-12--t column-end-11--d"

  const totalQuotes = quotes.length;
  const [currentQuote, setCurrentQuote] = useState(0)

  useEffect(() => {
    if (typeof window === 'undefined') return false;
    const cards = document.querySelectorAll('.home-social-proof__quote-card ');
    let largest = 0;

    cards.forEach(card => {
      card.style.height = `auto`
    })

    cards.forEach(card => {
      if (card.offsetHeight > largest) largest = card.offsetHeight;
    })

    cards.forEach(card => {
      card.style.height = `${largest}px`
    })
  }, [currentQuote])

  useEffect(()=> {
    const timeout = setTimeout(()=> {
      setCurrentQuote((currentQuote + 1) % totalQuotes);
    }, 7000)
    return () => { clearTimeout(timeout) }
  }, [currentQuote])

  return (
    <Section className="home-social-proof" styles={styles} >
      <div className={"home-social-proof-grid grid"}>
        {
          quotes.map((quote, i) => (
            <div className={`home-social-proof__quote flex flex-center ${currentQuote === i ? 'active' : 'inactive' } ${i % 2 ? rightColumn : leftColumn}`} key={'quote_' + i} >
              {!!(i % 2) && <Spacer size={[0, 100]} />}
              <div className={`home-social-proof__quote-card flex flex-center`}>
                <div>
                  <Spacer size={[55, 40]} />
                  <img className={'home-social-proof__photo'} src={quote.referenceQuoteImage.defaultImage.file.url} alt={quote.referenceQuoteImage.description} />
                  <Spacer size={[15, 24]} />
                  <p className={'home-social-proof__quote-copy'}>{quote.quoteCopy.quoteCopy}</p>
                  <Spacer size={[15, 15]} />
                  <p className={'home-social-proof__quote-byline'}>
                    <span className={'home-social-proof__quote-author'}>{quote.quoteByline}</span><br/>
                    <span className={'home-social-proof__quote-author-title'}>{quote.quoteDescriptor}</span>
                  </p>
                  <Spacer size={[55, 40]} />
                </div>
              </div>
            </div>
          ))
        }
      </div>
      <Spacer size={[50, 100]} />
    </Section>
  )
}

function OurStory ({hed, dek, cta, to}) {
  const styles = {
    '--color': 'var(--white)',
    '--background-color': 'var(--light-purple)',
  }

  return (
    <Section className="home-our-story" styles={styles} >
      <div className={"home-our-story-grid grid"}>
        <div className={'home-our-story__copy column-start-1 column-end-6 column-start-2--d column-end-9--t column-end--9--d'}>
          <HeroTertiary className={'home-our-story__hed'}>
            <span dangerouslySetInnerHTML={{ __html: hed }} />
          </HeroTertiary>
          <Spacer size={[24, 24]} />
          <CopyPrimary className={'home-our-story__dek'}>
            <span dangerouslySetInnerHTML={{ __html: dek }} />
          </CopyPrimary>
          <Spacer size={[40, 40]} />
          <Link className={'home-our-story__cta button button--yellow'} to={to}>{cta}</Link>
        </div>
      </div>
    </Section>
  )
}

function Questions({
  hed, dek,
  question1, question2, question3,
  answer1, answer2, answer3,
  cta, to,
  largeImage, smallImage,
  largeImageAlt, smallImageAlt,
  mobileImage, mobileImageAlt
}) {
  const styles = {
    '--color': 'var(--light-purple)',
    '--background-color': 'var(--white)',
  }

  const [questionState, setQuestionState] = useState([false, false, false])

  const handleToggleQuestion = (index) => {
    const newState = [...questionState];
    newState[index] = !newState[index];
    setQuestionState(newState)
  }

  return (
    <Section className="home-questions" styles={styles} >
      <div className={"home-questions-grid grid"}>
        <div className={'home-questions__copy column-start-1 column-end-6 column-start-2--t column-start-3--d column-end-11--t column-end--10--d'}>
          <HeroTertiary className={'home-questions__hed'}><span dangerouslySetInnerHTML={{ __html: hed }} /></HeroTertiary>
          <Spacer size={[20, 24]} />
          <CopyPrimary className={'home-questions__dek'}><span dangerouslySetInnerHTML={{ __html: dek }} /></CopyPrimary>
          <Spacer size={[30, 40]} />
        </div>
        <div className={'home-questions__question-group column-start-1 column-end-6 column-end-12--t'}>
          <div className={'home-questions__question-group-alignment'}>
            <div className={`home-questions__question-item home-questions__question-1 ${questionState[0] ? 'open' : 'closed'}`}>
              <h3 className={'home-questions__question'} onClick={()=> handleToggleQuestion(0)}>{question1}</h3>
              <Spacer size={[5, 0]} />
              <CopyPrimary className={'home-questions__answer'}>{answer1}</CopyPrimary>
              <Spacer size={[20, 0]} />
            </div>
            <div className={`home-questions__question-item home-questions__question-2 ${questionState[1] ? 'open' : 'closed'}`}>
              <h3 className={'home-questions__question'} onClick={()=> handleToggleQuestion(1)}>{question2}</h3>
              <Spacer size={[5, 0]} />
              <CopyPrimary className={'home-questions__answer'}>{answer2}</CopyPrimary>
              <Spacer size={[20, 0]} />
            </div>
            <div className={`home-questions__question-item home-questions__question-3 ${questionState[2] ? 'open' : 'closed'}`}>
              <h3 className={'home-questions__question'} onClick={()=> handleToggleQuestion(2)}>{question3}</h3>
              <Spacer size={[5, 0]} />
              <CopyPrimary className={'home-questions__answer'}>{answer3}</CopyPrimary>
              <Spacer size={[30, 0]} />
            </div>
            <img className={'home-questions__small-image'} src={smallImage} alt={smallImageAlt} />
            <img className={'home-questions__large-image'} src={largeImage} alt={largeImageAlt} />
            <img className={'home-questions__mobile-image'} src={mobileImage} alt={mobileImageAlt} />
          </div>
        </div>
        <div className={'home-questions__cta-group  column-start-1 column-end-6 column-end-12--t flex flex-center'}>
          <div>
            <Spacer size={[30, 35]} />
            <Link className={'home-questions__cta button button--yellow'} to={to}>{cta}</Link>
          </div>
        </div>
      </div>
    </Section>
  )
}

function Pillars({
  hed,
  parentHed, parentDek,
  kidsHed, kidsDek,
  familiesHed, familiesDek,
  parentScreen, kidsScreen, familiesScreen,
  parentScreenAlt, kidsScreenAlt, familiesScreenAlt
}) {
  const styles = {
    '--color': 'var(--white)',
    '--active-color': 'var(--yellow)',
    '--background-color': 'var(--light-purple)',
  }

  const totalScreens = 3;
  const [currentScreen, setCurrentScreen] = useState(0);

  const handleNext = (e) => {
    e.preventDefault();
    setCurrentScreen((currentScreen + 1) % totalScreens);
  }

  const handlePrevious = (e) => {
    e.preventDefault();
    setCurrentScreen((totalScreens + (currentScreen - 1)) % totalScreens)
  }

  const handleGoTo0 = (e) => {
    e.preventDefault();
    setCurrentScreen(0);
  }

  const handleGoTo1 = (e) => {
    e.preventDefault();
    setCurrentScreen(1);
  }

  const handleGoTo2 = (e) => {
    e.preventDefault();
    setCurrentScreen(2);
  }

  return (
    <Section className="home-pillars" styles={styles} >
      <div className={"home-pillars-grid grid"}>
        <div className={'home-pillars__copy column-start-1 column-end-6 column-start-2--d column-end-7--t'}>
          <HeroTertiary className={'home-pillars__title'}> <span dangerouslySetInnerHTML={{ __html: hed }} /></HeroTertiary>
          <Spacer size={[36, 40]} />
        </div>
      </div>
      <div className={"home-pillars-grid grid"}>
        <div className={'home-pillars__screen-group column-start-1 column-end-6 column-start-8--t column-end-12--t flex flex-center'}>
          <div style={{width: '100%'}}>
            <div className={'home-pillars__spacing flex flex-center'}>
              <button className={'reset home-pillars__previous'} alt={'previous slide'} onClick={handleNext}></button>
              <img className={`home-pillars__screen-parents  ${currentScreen === 0 ? 'active' : 'inactive'}`} src={parentScreen} alt={parentScreenAlt} />
              <img className={`home-pillars__screen-kids  ${currentScreen === 1 ? 'active' : 'inactive'}`} src={kidsScreen} alt={kidsScreenAlt} />
              <img className={`home-pillars__screen-families  ${currentScreen === 2 ? 'active' : 'inactive'}`} src={familiesScreen} alt={familiesScreenAlt} />
              <button className={'reset home-pillars__next'} alt={'previous slide'} onClick={handlePrevious}></button>
            </div>
            <Spacer size={[30, 0]} />
          </div>
        </div>
        <div className={'home-pillars__pillar-group column-start-1 column-end-6 column-start-2--d column-end-7--t'}>
          <div className={`home-pillars__pillar ${currentScreen === 0 ? 'active' : 'inactive'}`} onClick={handleGoTo0}>
            <h3 className={'home-pillars__hed'}><span dangerouslySetInnerHTML={{ __html: parentHed }} /></h3>
            <Spacer size={[10, 8]} />
            <p className={'home-pillars__dek'}><span dangerouslySetInnerHTML={{ __html: parentDek }} /></p>
            <Spacer size={[0, 40]} />
          </div>
          <div className={`home-pillars__pillar ${currentScreen === 1 ? 'active' : 'inactive'}`} onClick={handleGoTo1}>
            <h3 className={'home-pillars__hed'}><span dangerouslySetInnerHTML={{ __html: kidsHed }} /></h3>
            <Spacer size={[10, 8]} />
            <p className={'home-pillars__dek'}><span dangerouslySetInnerHTML={{ __html: kidsDek }} /></p>
            <Spacer size={[0, 40]} />
          </div>
          <div className={`home-pillars__pillar ${currentScreen === 2 ? 'active' : 'inactive'}`} onClick={handleGoTo2}>
            <h3 className={'home-pillars__hed'}><span dangerouslySetInnerHTML={{ __html: familiesHed }} /></h3>
            <Spacer size={[10, 8]} />
            <p className={'home-pillars__dek'}><span dangerouslySetInnerHTML={{ __html: familiesDek }} /></p>
          </div>
        </div>
      </div>
      <Spacer size={[50, 40]} />
    </Section>
  )
}

function VideoCalling ({hed, dek}) {
  const styles = {
    '--color': 'var(--light-purple)',
    '--background-color': 'var(--white)',
  }

  return (
    <Section className="home-video-calling" styles={styles} >
      <Spacer size={[60, 80]} />
      <div className={"home-video-calling-grid grid"}>
        <div className={'column-start-1 column-end-6 column-start-8--t column-end-12--t'}>
          <img alt="Video call on a phone." src="/home/video-calling-mockup.png" />
        </div>
        <div className={'column-start-1 column-end-6 column-start-2--t column-end-7--t'}>
          <Spacer size={[30, 35]} />
          <HeroTertiary className={'home-video-calling__hed'}>{hed}</HeroTertiary>
          <Spacer size={[20, 24]} />
          <CopyPrimaryDiv className={'home-video-calling__dek'}>
            {compile(dek).tree}
          </CopyPrimaryDiv>
          <Spacer size={[32, 60]} />
          <div className="home-video-calling__icons flex">
            <img className="home-video-calling__icon-video" alt="Video Calling" src="/home/video-icon-1.svg" />
            <img className="home-video-calling__icon-blip " alt="Blip Video Calling" src="/home/video-icon-2.svg" />
          </div>
          <Spacer size={[40, 56 ]} />
        </div>
        <div className={'column-start-1 column-end-6 column-end-12--t flex flex-center'}>
          <Spacer size={[0, 20]} />
          <Link className={'home-our-story__cta button button--yellow'} to="/blog/inside-kinzoo/how-kinzoo-is-working-to-make-video-calling-more-meaningful">Read More</Link>
        </div>
      </div>
      <Spacer size={[20, 0]} />
    </Section>
  )
}

export default function Page({data}) {
  const { referencePageMetadata } = data.contentfulSingletonHomepage;
  const { heroHed, heroDek } = data.contentfulSingletonHomepage;
  const { walkThroughHed, walkThroughDek } = data.contentfulSingletonHomepage;
  const { videoCallingHed, videoCallingDek } = data.contentfulSingletonHomepage;
  const { referenceQuoteCarousel } = data.contentfulSingletonHomepage;
  const { ourStoryHed, ourStoryDek, ourStoryCta, ourStoryLink } = data.contentfulSingletonHomepage;
  const { faqHed, faqDek, faqCta, faqLink } = data.contentfulSingletonHomepage;
  const { faqQuestion1, faqQuestion2, faqQuestion3 } = data.contentfulSingletonHomepage;
  const { faqAnswer1, faqAnswer2, faqAnswer3 } = data.contentfulSingletonHomepage;
  const { faqSmallImage, faqLargeImage, faqMobileFooterImage } = data.contentfulSingletonHomepage;
  const { pillarsHed } = data.contentfulSingletonHomepage;
  const { parentsHed, parentsDek, parentScreen } = data.contentfulSingletonHomepage;
  const { kidsHed, kidsDek, kidScreen } = data.contentfulSingletonHomepage;
  const { familiesHed, familiesDek, familiesScreen } = data.contentfulSingletonHomepage;

  return(
    <PageContainer>
      <Helmet>
        <link rel="canonical" href="https://kinzoo.com/" />
        <meta property="og:url" content="https://kinzoo.com/" />
        <link rel="preload" href="/home/hero-video-poster.jpg" as="image" />
        <link rel="preload" href="/home/hero-video-mobile.png" as="image" />
        <link rel="preload" href="/home/hero-video-desktop.png" as="image" />
      </Helmet>
      <Metadata {...referencePageMetadata} />
      <Header styles={styles} />
      <Hero hed={heroHed} dek={heroDek.heroDek} />
      <WalkThrough hed={walkThroughHed} dek={walkThroughDek.walkThroughDek} />
      <VideoCalling hed={videoCallingHed} dek={videoCallingDek.videoCallingDek} />
      <SocialProof quotes={referenceQuoteCarousel} />
      <OurStory hed={ourStoryHed} dek={ourStoryDek.ourStoryDek} cta={ourStoryCta} to={ourStoryLink} />
      <Questions
        hed={faqHed} dek={faqDek.faqDek} cta={faqCta} to={faqLink}
        question1={faqQuestion1} question2={faqQuestion2} question3={faqQuestion3}
        answer1={faqAnswer1.faqAnswer1} answer2={faqAnswer2.faqAnswer2} answer3={faqAnswer3.faqAnswer3}
        smallImage={faqSmallImage.file.url} largeImage={faqLargeImage.file.url}
        smallImageAlt={faqSmallImage.title} largeImageAlt={faqLargeImage.title}
        mobileImage={faqMobileFooterImage.file.url} mobileImageAlt={faqMobileFooterImage.title}
      />
      <Pillars
        hed={pillarsHed}
        parentHed={parentsHed} parentDek={parentsDek.parentsDek}
        kidsHed={kidsHed} kidsDek={kidsDek.kidsDek}
        familiesHed={familiesHed} familiesDek={familiesDek.familiesDek}
        parentScreen={parentScreen.file.url} parentScreenAlt={parentScreen.title}
        kidsScreen={kidScreen.file.url} kidsScreenAlt={kidScreen.title}
        familiesScreen={familiesScreen.file.url} familiesScreenAlt={familiesScreen.title}
      />
      <DownloadBanner/>
      <Footer />
    </PageContainer>
  )
}

export const pageQuery = graphql`
  query HomePageQuery {
    contentfulSingletonHomepage(contentful_id: { eq: "Jju8Hr697vvyjRjQuj1XO" }) {
      referencePageMetadata {
        pageTitle
        ogTitle
        twitterTitle
        description
        ogDescription
        twitterDescription
        ogImage {
          file {
            url
          }
        }
        twitterImage {
          file {
            url
          }
        }
      }

      heroHed
      heroDek {
        heroDek
      }

      walkThroughHed
      walkThroughDek {
        walkThroughDek
      }

      videoCallingHed
      videoCallingDek {
        videoCallingDek
      }

      referenceQuoteCarousel {
        quoteByline
        quoteDescriptor
        quoteCopy {
          quoteCopy
        }
        referenceQuoteImage {
          description
          defaultImage {
            file {
              url
            }
          }
        }
      }

      ourStoryHed
      ourStoryDek {
        ourStoryDek
      }
      ourStoryCta
      ourStoryLink

      faqHed
      faqDek {
        faqDek
      }
      faqCta
      faqLink
      faqQuestion1
      faqQuestion2
      faqQuestion3
      faqAnswer1 {
        faqAnswer1
      }
      faqAnswer2 {
        faqAnswer2
      }
      faqAnswer3 {
        faqAnswer3
      }
      faqSmallImage {
        title
        file {
            url
        }
      }
      faqLargeImage {
        title
        file {
            url
        }
      }
      faqMobileFooterImage {
        title
        file {
            url
        }
      }

      pillarsHed
      parentsHed
      parentsDek {
        parentsDek
      }
      parentScreen {
        title
        file {
            url
        }
      }
      kidsHed
      kidsDek {
        kidsDek
      }
      kidScreen {
        title
        file {
            url
        }
      }
      familiesHed
      familiesDek {
        familiesDek
      }
      familiesScreen {
        title
        file {
            url
        }
      }

    }
  }
`
